<template>
  <div class="col-100 col-lg-75" :class="{'ps-0' : screenWidth < 992}, {'pe-lg-0' : screenWidth >= 992}">
    <div v-if="eventStore.searched" class="search-count">{{ eventStore.loading || eventStore.searchLoading ? 'Lädt' : eventStore.contentSearchResults.length }} {{ eventStore.contentSearchResults.length == 1 ? `Ergebnis wurde mit Ihrem Suchbegriff "${eventStore.searchedTerm}" gefunden` : `Ergebnisse wurden mit Ihrem Suchbegriff "${eventStore.searchedTerm}" gefunden` }}</div>
    <div class="products__body">
      <template v-if="!eventStore.loading && !eventStore.searchLoading">
        <template v-for="(searchItem, index) in eventStore.contentSearchResults">
          <ContentSearchItem
            v-if="index < activePage * elementsPerPage && index >= (activePage - 1) * elementsPerPage"
            :key="searchItem.id"
            :searchItem="searchItem"
          />
        </template>
        <div v-if="eventStore.contentSearchResults.length <= 0" class="products__no-result">
          <strong>{{ eventStore.searchInput && eventStore.wasSearched ? "Leider ergab Ihre Suche kein Ergebnis." : "Bitte geben Sie einen Suchbegriff ein," }}</strong><br>{{ eventStore.searchInput && eventStore.wasSearched ? "Bitte versuchen Sie es erneut..." : "um die Website zu durchsuchen." }}
        </div>
        <div v-if="totalPages > 1" class="pagination">
          <button @click.prevent="activePage--" @click="scrollToTop" aria-label="Vorherige Seite">Vorherige<span v-if="screenWidth >= 1200 || screenWidth < 768">&nbsp;Seite</span></button>
          <div class="pagination__list">
            <button v-if="screenWidth >= 768" :aria-label="btn !== '...' ? `Seite ${btn}` : 'Lückenfüller Button mit drei Punkten'" v-for="btn in paginationButtons" :class="{'active' : btn == activePage}" @click="scrollToTop" @click.prevent="activePage = btn !== '...'  ? btn : activePage" :disabled="btn == '...'">{{ btn }}</button>
            <select v-if="screenWidth < 768" v-model="activePage" aria-label="Seitenauswahl">
              <option v-for="page of totalPages" :value="`${page}`">Seite {{ page }}</option>
            </select>
          </div>
          <button @click.prevent="activePage++" @click="scrollToTop" aria-label="Nächste Seite">Nächste<span v-if="screenWidth >= 1200 || screenWidth < 768">&nbsp;Seite</span></button>
        </div>
      </template>
      <template v-else>
        <!-- LOADING STATE -->
         <div class="loading">
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, ref, watch, onUnmounted } from 'vue';
import { defineStore } from 'pinia';

import ContentSearchItem from '../../components/ContentSearchItem.vue';

const useEventStore = defineStore('event');

const eventStore = useEventStore();

const startingPage = ref(1);
const elementsPerPage = ref(5);
const totalPages = computed (() => Math.ceil(eventStore.contentSearchResults.length / elementsPerPage.value));

const activePage = computed({
  get: () => startingPage.value,
  set: (newVal) => {
    if (newVal < 1){
      startingPage.value = 1;
    } else if (newVal > totalPages.value) {
      startingPage.value = totalPages.value
    } else {
      startingPage.value = newVal;
    }
  }
})

const scrollToTop = () => {
  const scrollTo = document.querySelector('.products__body');
  const header = document.querySelector('.navbar');
  const topmeta = document.querySelector('.topmeta')
  const headerHeight = header.offsetHeight;
  const topmetaHeight = topmeta.offsetHeight;

  const elementPosition = scrollTo.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - headerHeight - topmetaHeight;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
}

/*
*   computed property, um die richtigen Buttons für Pagination zu generieren
*/

const paginationButtons = computed(() => {
  const buttons = [];

  activePage.value = Number.parseInt(activePage.value);

  if (totalPages.value <= 7) {
    // Wenn es wenige Seiten gibt, zeige alle Buttons
    for (let i = 1; i <= totalPages.value; i++) {
      buttons.push(i);
    }
  } else {
    // Sonderfälle für Anfang und Ende mit "..."
    if (activePage.value <= 4){
      for (let i = 1; i < 6; i++) {
        buttons.push(i);
      }
      buttons.push("...");
      buttons.push(totalPages.value);
    } else if (activePage.value >= totalPages.value - 3) {
      buttons.push(1);
      buttons.push("...");
      for (let i = totalPages.value - 4; i <= totalPages.value; i++) {
        buttons.push(i);
      }
    } else {
      buttons.push(1);
      buttons.push("...");
      buttons.push(activePage.value - 1);
      buttons.push(activePage.value);
      buttons.push(activePage.value + 1);
      buttons.push("...");
      buttons.push(totalPages.value);
    }
  }

  return buttons;
});

watch(() => eventStore.contentSearchResults, newVal => {
  activePage.value = 1;
})

/*
*   Mediabreakpoint für Pagination beobachten
*/

const screenWidth = ref(window.innerWidth);

const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
}

onMounted(async () => {
  window.addEventListener('resize', updateScreenWidth);

  // loadSearchItems();
});

onUnmounted(() => {
  window.removeEventListener('resize', updateScreenWidth);
})
</script>

<style lang="scss" scoped>

</style>
